import { useTranslation } from 'react-i18next'
import { Paper, Typography } from '@mui/material'

export function NoConflicts() {
  const { t } = useTranslation()
  return (
    <Paper sx={{ p: 4, textAlign: 'center' }}>
      <Typography variant="h6" color="text.secondary">
        {t('sync.conflict.noConflicts')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        {t('sync.conflict.allOperationsCompleted')}
      </Typography>
    </Paper>
  )
}
